module.exports = __webpack_public_path__ + "img/kid-right.6abecf13.svg";